import { createAction } from '@reduxjs/toolkit';
import uniqueId from 'lodash/uniqueId';
import type { NotificationModel } from './types';
import type { RootState } from '../store';
import type { AnyAction } from 'redux';
import type { ThunkAction } from 'redux-thunk';

export const pushNotification = createAction<NotificationModel>('@@notification/PUSH_NOTIFICATION');

export const popNotification = createAction<NotificationModel>('@@notification/POP_NOTIFICATION');

export function showNotificationAsync(
    message: string,
    timeout: number = 3500,
): ThunkAction<void, RootState, undefined, AnyAction> {
    return async (dispatch) => {
        const notification: NotificationModel = { id: uniqueId('notification_'), message };
        dispatch(pushNotification(notification));

        setTimeout(() => {
            dispatch(popNotification(notification));
        }, timeout);
    };
}
